<template>
  <div>
    <!-- Modelo de página -->
    <div class="theme-page-section theme-page-section-gray theme-page-section-lg">
      <div class="container">
        <div class="row mt-90">
          <!-- Componente menu -->
          <account-menu />
          <!-- /Componente menu -->
          <div class="col-md-10">
            <!-- Titulo -->
            <h1 class="theme-account-page-title">Dependentes</h1>
            <!-- /Titulo -->
            <div class="row">
              <div class="col-md-12 padding-off">
                <!-- Subtitulo -->
                <div class="col-md-12">
                  <h4 class="title-manage-account">Dependentes cadastrados</h4>
                </div>
                <!-- /Subtitulo -->
                <!-- Card adicionar novo dependente -->
                <div class="col-md-6 mb-20">
                  <div class="theme-account-traveler">
                    <router-link to="/add-travelerdependent">
                      <a class="theme-account-traveler-link-mask"></a>
                      <p class="theme-account-traveler-add-new">+ Adicionar novo dependente</p>
                    </router-link>
                  </div>
                </div>
                <!-- Card adicionar novo dependente -->
                <!-- Componente card dependente -->
                <card-traveler-dependent
                  v-for="traveler in travelers"
                  v-if="$store.state.auth.user.id != traveler.id"
                  :traveler="traveler"
                  :key="traveler.id"
                ></card-traveler-dependent>
                <!-- Componente card dependente -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Modelo de página -->
    <lockscreen :loading="loading"></lockscreen>
  </div>
</template>

<script>
import AccountMenu from "@/components/template/AccountMenu";
import CardTravelerDependent from "../components/cardtravelerdependent.vue";
import lockscreen from "../components/lockscreen/index.vue";
import alerts from "../mixins/alerts";

export default {
  validator: null,
  data() {
    return {
      travelers: [],
      loading: false,
      submitted: false,
      all_dependents: this.$route.query.all_dependents,
    };
  },
  watch: {
    $route(to, from) {
      this.all_dependents = to.query.all_dependents
      this.get_dependents()
      }
  },
  components: {
    AccountMenu,
    CardTravelerDependent,
    lockscreen
  },
  mixins: [alerts],
  beforeCreate() {},
  created() {
    this.loading = true;
    this.get_dependents()
  },
  methods: {
    get_dependents() {
    let type_dependents = this.all_dependents ? this.all_dependents : false
    let url = `/api/user/travelers/parent/?is_active_all=true&all_dependents=${type_dependents}`;
      this.$http
      .get(url)
      .then(response => {
        if (response.status === 200) {
          this.travelers = response.data;
          this.travelers.sort(function (a, b) {
            return a.is_active > b.is_active ? -1 : 1;
          });
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        }
      })
      .catch(() => {
        /**/
      });
    }
  }
};

</script>

<style scoped>
.change-modal {
  border-radius: 0;
}
.change-modal-header {
  border: 0 !important;
}
.change-modal-footer {
  border: 0 !important;
}
.content-change-modal {
  height: 350px;
  overflow-y: auto;
  font-size: 14px;
  padding-left: 40px;
  padding-right: 40px;
}
</style>
